import React, { useEffect, useState } from 'react';
import {GetLocation} from "datasync-core";

const IPCity = () => {
  const [location, setLocation] = useState({ latitude: null, longitude: null, city:null });
  const [error, setError] = useState('');

  useEffect(() => {
    GetLocation({onLocation:(locationObj)=>{setLocation(locationObj)}, onError:(msg)=>{setError(msg)}})
  }, []);

  return (
    <div>
      <h2>City Location</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {location.city && <p>City : {location.city}</p>}
      {location.latitude && location.longitude ? (
        <p>Latitude: {location.latitude}, Longitude: {location.longitude}</p>
      ) : (
        !error && <p>Detecting location...</p>
      )}
    </div>
  );
};

export default IPCity;
